import React from "react";
import { useApp } from "@/context/AppContext";
import { BRANDS } from "@/data/content";

export default function Footer() {
  const { t } = useApp();
  return (
    <footer className="relative bg-navy text-white pt-20 pb-10 overflow-hidden" data-testid="footer">
      <div className="border-y border-cyan/15 py-6 overflow-hidden mb-16">
        <div className="flex whitespace-nowrap animate-marquee">
          {[...BRANDS, ...BRANDS, ...BRANDS].map((b, i) => (
            <span key={`${b}-${i}`} className="font-display text-3xl md:text-5xl tracking-tight text-white/25 mx-8">{b}</span>
          ))}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row justify-between gap-10 items-start">
          <div>
            <img
              src="/logo-mne.png"
              alt="Marine Nav Electronics"
              className="h-14 md:h-16 w-auto object-contain mb-5 drop-shadow-[0_2px_10px_rgba(0,150,199,0.35)]"
            />
            <p className="text-slate text-sm max-w-xs">{t.footer.tag}</p>
          </div>
          <div className="grid grid-cols-2 gap-x-16 gap-y-3">
            {Object.entries(t.nav).map(([k, v]) => (
              <a key={k} href={`#${k === "contact" ? "contact" : k}`} className="font-mono text-xs uppercase tracking-wider text-slate hover:text-cyan transition-colors" data-testid={`footer-link-${k}`}>{v}</a>
            ))}
          </div>
        </div>
        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-slate">
          <p className="font-mono text-xs">© {new Date().getFullYear()} Marine Nav Electronics. {t.footer.rights}</p>
          <p className="font-mono text-xs">Fort Lauderdale · Miami · Palm Beach</p>
        </div>
      </div>
    </footer>
  );
}
